import { AxiosResponse } from 'axios'
import { ElMessage } from 'element-plus'
import defaultRules from './defaults'
import {
  IDDErrorHandler,
  IDDErrorHandlerError,
  IDDErrorHandlerErrorList,
} from './dd-error-handler.types'
import { Router } from 'vue-router'
import strings from '@/plugins/dd-strings/dd-strings.strings'

export default class DDErrorHandler implements IDDErrorHandler {
  private router: Router

  constructor(router: Router) {
    this.router = router
  }

  public emit(
    error: AxiosResponse,
    exposeDataErrorsAsNotifications: boolean = false,
  ) {
    if (!error || !error.status) {
      if (import.meta.env.DEV) {
        throw new Error('No error provided for error....that is an error!')
      }
      return false
    }

    let rules: IDDErrorHandlerErrorList = {}

    if (exposeDataErrorsAsNotifications) {
      rules = {
        503: {
          notification: {
            message: error.data
              ? error.data.message
              : strings.GENERIC_ERROR_MESSAGE,
          },
        },
        500: {
          notification: {
            message: error.data
              ? error.data.message
              : strings.GENERIC_ERROR_MESSAGE,
          },
        },
        404: {
          notification: {
            message: error.data
              ? error.data.message
              : strings.GENERIC_ERROR_MESSAGE,
          },
        },
        403: {
          notification: {
            message: error.data
              ? error.data.message
              : strings.GENERIC_ERROR_MESSAGE,
          },
        },
        429: {
          notification: {
            message: error.data
              ? error.data.message
              : strings.GENERIC_ERROR_MESSAGE,
          },
        },
      }
    }

    if (rules[error.status]) {
      this.executeRule(error, rules[error.status])
    } else {
      this.executeDefaultRule(error)
    }
  }

  private executeDefaultRule(error: AxiosResponse) {
    const defaultRule = defaultRules[error.status]
    if (defaultRule) {
      this.executeRule(error, defaultRule)
    }
  }

  private executeRule(error: AxiosResponse, rule: IDDErrorHandlerError) {
    if (import.meta.env.DEV) {
      console.error('[DDErrorHandler]: Error:', error)
      console.error('[DDErrorHandler]: Rule to execute: ', rule)
    }

    if (rule.hasOwnProperty('handler')) {
      rule.handler(this.router, error, {})
    }

    if (rule.hasOwnProperty('notification')) {
      ElMessage({
        type: rule.notification.type || 'error',
        message:
          rule.notification.message ||
          error.data.message ||
          strings.GENERIC_ERROR_MESSAGE,
        offset: 20, // Element UI's; Element Plus defaults to 16
      })
    }

    if (rule.hasOwnProperty('redirect')) {
      this.router.push(rule.redirect)
    }
  }
}
